/* Shop Tracker - Shopify consent-sync v1.0.1 */
/**
 * GMU CookieBanner — Shopify consent-sync.
 *
 * Zet de keuze uit de GMU-banner door naar Shopify's Customer Privacy API
 * (window.Shopify.customerPrivacy.setTrackingConsent). Daarmee schrijft
 * Shopify zijn eigen consent-cookie (_tracking_consent), die meereist naar de
 * checkout. Daar lezen app-pixels (Google & YouTube, Meta), custom pixels met
 * permission "Required" en onze eigen checkout-pixel (init.customerPrivacy /
 * event.context.privacy_policy) de keuze weer uit.
 *
 * Zonder dit script kent Shopify de keuze niet: alle vier de consentvelden
 * blijven leeg, app-pixels blijven stil en de checkout-pixel ziet nooit een
 * weigering.
 *
 * De banner zelf is platform-onafhankelijk en praat alleen via de dataLayer:
 *   cmp_choice_made     { choices }   nieuwe keuze in de banner
 *   cmp_state_restored  { consent_id, age_days }   opgeslagen keuze bij herbezoek
 *   cmp_withdrawn       { }           keuze ingetrokken
 * cmp_state_restored draagt géén choices. Ontbreken ze, dan komt de keuze
 * uit window.ShopBanner.getState(): de banner zet die state vóórdat hij het
 * event pusht, en de publieke getter is stabieler dan zijn localStorage-keys.
 * Is de keuze zo niet te bepalen, dan sturen we niets: "onbekend" is geen
 * weigering, en de consent die Shopify al heeft blijft dan staan.
 * Dit script onderschept dataLayer.push en handelt die drie events af. Events
 * die al in de dataLayer stonden vóór dit script laadde (de banner laadt
 * async, dit script defer) worden één keer nagespeeld: alleen het laatste.
 *
 * Mapping GMU-categorie -> Shopify-doel:
 *   analytics      -> analytics
 *   marketing      -> marketing en sale_of_data
 *   personalization-> preferences (ontbreekt de categorie, dan true: de
 *                     banner kent geen aparte functionele categorie en
 *                     noodzakelijke cookies zijn altijd toegestaan)
 */
(function () {
  'use strict';

  var EVENTS = { cmp_choice_made: true, cmp_state_restored: true, cmp_withdrawn: true };
  var DENIED = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
  var lastSignature = '';

  function toShopifyConsent(choices) {
    var c = choices || {};
    var marketing = c.marketing === true;
    return {
      analytics:    c.analytics === true,
      marketing:    marketing,
      preferences:  'personalization' in c ? c.personalization === true : true,
      sale_of_data: marketing
    };
  }

  function consentFor(entry) {
    if (entry.event === 'cmp_withdrawn') return DENIED;
    var choices = entry.choices || bannerChoices();
    return choices ? toShopifyConsent(choices) : null;
  }

  function bannerChoices() {
    var banner = window.ShopBanner;
    var state = banner && typeof banner.getState === 'function' ? banner.getState() : null;
    return state && state.choices ? state.choices : null;
  }

  function isCmpEvent(entry) {
    return !!(entry && typeof entry === 'object' && EVENTS[entry.event]);
  }

  function pushToShopify(consent) {
    var signature = JSON.stringify(consent);
    if (signature === lastSignature) return;      // zelfde keuze -> geen extra call
    lastSignature = signature;

    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') return;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) {
          lastSignature = '';                       // volgende keuze opnieuw proberen
          if (window.console) console.warn('[GMU consent-sync] consent-tracking-api niet geladen', error);
          return;
        }
        var api = window.Shopify && window.Shopify.customerPrivacy;
        if (!api || typeof api.setTrackingConsent !== 'function') return;
        api.setTrackingConsent(consent, function () {});
      });
    } catch (e) {
      lastSignature = '';
      if (window.console) console.warn('[GMU consent-sync] doorzetten mislukt', e);
    }
  }

  function handle(entry) {
    if (!isCmpEvent(entry)) return;
    var consent = consentFor(entry);
    if (consent) pushToShopify(consent);
  }

  var dl = window.dataLayer = window.dataLayer || [];

  // 1) Naspelen wat er al staat: alleen het laatste cmp-event telt.
  for (var i = dl.length - 1; i >= 0; i--) {
    if (isCmpEvent(dl[i])) { handle(dl[i]); break; }
  }

  // 2) Nieuwe pushes onderscheppen. De originele push blijft leidend, ook
  //    als GTM die inmiddels vervangen heeft door zijn eigen implementatie.
  var originalPush = dl.push;
  dl.push = function () {
    var result = originalPush.apply(dl, arguments);
    for (var j = 0; j < arguments.length; j++) {
      try { handle(arguments[j]); } catch (e) { /* nooit de dataLayer breken */ }
    }
    return result;
  };
})();
